import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col w-full gap-4 p-2" };
const _hoisted_2 = { class: "mt-4" };
const _hoisted_3 = { class: "flex flex-col gap-4" };
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import Divider from 'primevue/divider';
import Sidebar from 'primevue/sidebar';
import Fieldset from 'primevue/fieldset';
import { useFetch, useHandleError, useUserPreferences } from '@apparatix/composables';
import ChangePassword from '@apparatix/library/ChangePassword.vue';
import TwoFactorAuthentication from '@apparatix/library/TwoFactorAuthentication.vue';
import CreareApiToken from '@apparatix/library/CreateApiToken.vue';
import OfficeSelection from '@apparatix/library/OfficeSelection.vue';
import DesignSettings from '@apparatix/library/DesignSettings.vue';
import TimezoneSettings from '@apparatix/library/TimezoneSettings.vue';
import MailServerSettingsComponent from '@apparatix/library/MailServerSettings.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AccountSettings',
    props: {
        visible: { type: Boolean },
        user: {}
    },
    emits: ["updateVisible"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { get } = useFetch();
        const { updateOfficeSelection } = useUserPreferences();
        const errorHandler = useHandleError();
        const isLoading = ref(true);
        const viewModel = ref();
        const apiTokens = ref([]);
        const shouldShow = computed({
            get() {
                return props.visible;
            },
            set(value) {
                emit('updateVisible', value);
            },
        });
        const refreshApiTokens = async () => {
            const data = await get('/tokens');
            if (Array.isArray(data?.tokens)) {
                if (data.tokens.length > 0) {
                    apiTokens.value = data.tokens;
                }
                else {
                    apiTokens.value = [];
                }
            }
            else {
                apiTokens.value = [];
            }
        };
        const refreshOfficeSelection = async (selectedOffices) => {
            if (viewModel.value.selectedOffices === selectedOffices)
                return;
            const success = await updateOfficeSelection(selectedOffices);
            if (success) {
                viewModel.value.selectedOffices = selectedOffices;
            }
            else {
                errorHandler.handleError({ message: 'Error', logToSentry: true, toastDetail: 'There was an error saving your office preferences' });
            }
        };
        const openChangelog = () => {
            const url = `https://${window.location.host}/changelog.html`;
            window.open(url, '_blank');
        };
        onMounted(async () => {
            const vm = await get('/account-settings');
            if (vm) {
                viewModel.value = vm;
                if (Array.isArray(vm.apiTokens)) {
                    apiTokens.value = vm.apiTokens;
                }
            }
            else {
                errorHandler.handleError({
                    message: 'Error loading account settings',
                    showToast: false,
                });
            }
            isLoading.value = false;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Sidebar), {
                visible: shouldShow.value,
                "onUpdate:visible": _cache[1] || (_cache[1] = ($event) => ((shouldShow).value = $event)),
                visibleModifiers: { sync: true },
                modal: true,
                header: "Account Settings",
                position: "right",
                class: "w-full lg:w-2/3 xl:w-1/2"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(Fieldset), { legend: "Account" }, {
                            default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(props.user.displayName) + " (" + _toDisplayString(props.user.username) + ")", 1),
                                _createElementVNode("p", null, _toDisplayString(viewModel.value.appVersion), 1),
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_unref(Button), {
                                        size: "small",
                                        label: "Change log",
                                        onClick: openChangelog
                                    })
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Fieldset), { legend: "Security settings" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(ChangePassword),
                                    _createVNode(_unref(Divider)),
                                    _createVNode(TwoFactorAuthentication, {
                                        "is-two-factor-enabled": viewModel.value.isTwoFactorEnabled
                                    }, null, 8, ["is-two-factor-enabled"]),
                                    _createVNode(_unref(Divider)),
                                    _createVNode(CreareApiToken, {
                                        "api-tokens": apiTokens.value,
                                        "onUpdate:tokenList": refreshApiTokens
                                    }, null, 8, ["api-tokens"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Fieldset), { legend: "Office selection" }, {
                            default: _withCtx(() => [
                                _createVNode(OfficeSelection, {
                                    "allowed-offices": viewModel.value.allowedOffices,
                                    "selected-offices": viewModel.value.selectedOffices,
                                    "onUpdate:officeSelection": _cache[0] || (_cache[0] = selection => refreshOfficeSelection(selection))
                                }, null, 8, ["allowed-offices", "selected-offices"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Fieldset), { legend: "Display settings" }, {
                            default: _withCtx(() => [
                                _createVNode(DesignSettings, {
                                    "new-nav-enabled-globally": viewModel.value.newNavEnabledGlobally
                                }, null, 8, ["new-nav-enabled-globally"]),
                                _createVNode(TimezoneSettings, {
                                    class: "mt-4",
                                    selected: viewModel.value.timezone.selected,
                                    zones: viewModel.value.timezone.zones
                                }, null, 8, ["selected", "zones"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Fieldset), { legend: "Email settings" }, {
                            default: _withCtx(() => [
                                _createVNode(MailServerSettingsComponent, {
                                    type: "smtp",
                                    settings: viewModel.value.smtpSettings
                                }, null, 8, ["settings"]),
                                _createVNode(_unref(Divider)),
                                _createVNode(MailServerSettingsComponent, {
                                    type: "imap",
                                    settings: viewModel.value.imapSettings
                                }, null, 8, ["settings"])
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
